import type { ReactElement } from 'react';
import { Prompt, Typography } from '@weareopenr/component-library';
import type { DeleteEntityPrompt } from 'src/hooks/useDeleteEntityPrompt';
import styles from './DeleteEntityPrompts.module.scss';

export interface unaffectedEntities {
  entityLabel: string;
  entityName: string;
  unaffectedItems: string;
  deletePrompt: DeleteEntityPrompt;
}

export const DeleteEntityPrompts = ({
  entityLabel,
  entityName,
  unaffectedItems,
  deletePrompt,
}: unaffectedEntities): ReactElement => {
  const [firstParagraph, ...restParagraphs] = deletePrompt.inUseErrorMessage.split(/\r?\n\r?\n/).filter(Boolean);

  return (
    <>
      <Prompt
        promptHeading={`Are you sure you want to delete “${entityName}”?`}
        closePrompt={deletePrompt.closeDeletePrompt}
        open={deletePrompt.isRemovePromptVisible}
        buttonHandler={deletePrompt.confirmDelete}
        buttonText="Delete"
        buttonColour="tomato"
        backButton={true}
        backButtonText="Cancel"
        size="small"
        isSubmitting={deletePrompt.isSubmitting}
      >
        <Typography size="medium">
          Deleting this {entityLabel} will <u className={styles['emphasis']}>not</u> delete any {unaffectedItems} used
          within it.
        </Typography>
        <Typography size="small" className={styles['undone-text']}>
          This action cannot be undone.
        </Typography>
      </Prompt>
      <Prompt
        data-testid={`${entityLabel}-in-use-prompt`}
        promptHeading={entityName ? `Unable to delete “${entityName}”` : `Unable to delete ${entityLabel}`}
        closePrompt={deletePrompt.closeInUsePrompt}
        open={deletePrompt.isInUsePromptVisible}
        backButton={true}
        backButtonText="Cancel"
        size="small"
      >
        {firstParagraph && (
          <Typography size="medium" weight="bold">
            {firstParagraph}
          </Typography>
        )}
        {restParagraphs.map((paragraph) => (
          <Typography key={paragraph} size="medium" className={styles['in-use-text']}>
            {paragraph}
          </Typography>
        ))}
      </Prompt>
    </>
  );
};
